import {
  Box,
  Button,
  Popover,
  Stack,
  Typography,
  useTheme
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'src/app/hooks';
import {
  IEcommerceProductHierarchy,
  IEcommerceProductHierarchyItem,
  IEcommerceSubBrandHierarchy
} from 'src/models/ecommerce';
import useEcommerce from 'src/services/useEcommerce';
import FilterSubBrandList from './FilterSubBrandList';
import { reducerUpdateAdvanceSearch } from 'src/features/advanceSearchEcommerce';
import FloatingLabelButton from '../FloatingLabelButton';

export default function FilterSubBrand() {
  const theme = useTheme();
  const { selectedOriginalToPost, selectedSubBrand, selectedBrand } =
    useAppSelector((state) => state.storeAdvancedSearchEcommerce);
  const { objectListByObjectType } = useAppSelector(
    (state) => state.objectManagement
  );
  const [open, setOpen] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const dispatch = useAppDispatch();

  const projectId = useAppSelector((state) => state.users.project.id);
  const advanceSearchEcommerce = useAppSelector(
    (state) => state.storeAdvancedSearchEcommerce
  );
  const { useGetEcommerceStreamCommentingToProduct } = useEcommerce();

  const {
    data: streamsCommentingToPostData,
    loading: loadingStreamsCommentingToPost
  } = useGetEcommerceStreamCommentingToProduct({
    skip: !open,
    variables: {
      projectId: projectId,
      objectIds: objectListByObjectType.map((item) => item.id)
    },
    fetchPolicy: 'network-only'
  });

  const [selectedBrandLocal, setSelectedBrandLocal] =
    useState<IEcommerceProductHierarchy[]>(selectedBrand);
  const [selectedSubBrandLocal, setSelectedSubBrandLocal] =
    useState<IEcommerceSubBrandHierarchy[]>(selectedSubBrand);
  const [
    selectedCommentingToProductsLocal,
    setSelectedCommentingToProductsLocal
  ] = useState<IEcommerceProductHierarchyItem[]>(selectedOriginalToPost);

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpen(false);
  };

  const handleApply = () => {
    dispatch(
      reducerUpdateAdvanceSearch({
        ...advanceSearchEcommerce,
        replyToOriginalId: selectedCommentingToProductsLocal.map(
          (stream) => stream.originalId
        ),
        selectedOriginalToPost: selectedCommentingToProductsLocal,
        selectedBrand: selectedBrandLocal,
        selectedSubBrand: selectedSubBrandLocal
      })
    );
    handleClose();
  };

  useEffect(() => {
    setSelectedSubBrandLocal(selectedSubBrand);
    setSelectedCommentingToProductsLocal(selectedOriginalToPost);
  }, [selectedOriginalToPost, selectedSubBrand]);

  return (
    <>
      <Stack maxWidth="400px" width="100%" spacing={0.5}>
        <FloatingLabelButton
          chipList={selectedSubBrand.map((item) => item.name)}
          label="Sub-Brand"
          onClick={handleOpen}
          open={open}
        />
      </Stack>
      <Popover
        open={open}
        onClose={handleClose}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
      >
        <Box sx={{ p: theme.spacing(2), maxWidth: '600px', width: '100%' }}>
          <Typography variant="h4">Sub-Brand</Typography>
          <FilterSubBrandList
            data={
              streamsCommentingToPostData?.ecommerceProductManagement_getProductHierarchy ||
              []
            }
            loading={loadingStreamsCommentingToPost}
            selectedProducts={selectedCommentingToProductsLocal}
            onSelectedProductsChange={(
              products: IEcommerceProductHierarchyItem[]
            ) => {
              setSelectedCommentingToProductsLocal(products);
            }}
            selectedSubBrand={selectedSubBrandLocal}
            setSelectedSubBrand={setSelectedSubBrandLocal}
            setSelectedBrand={setSelectedBrandLocal}
          />
          <Stack pt={1} alignItems="end">
            <Button variant="contained" onClick={handleApply}>
              Apply
            </Button>
          </Stack>
        </Box>
      </Popover>
    </>
  );
}
